/** @type {import('../schema').ProcessDefinition} */
const empleadosSolicitudes = {
  id: "empleados-solicitudes",
  name: "Solicitudes / licencias de empleados",
  category: "personas",
  outcome:
    "Que el empleado pida licencias/permisos y el admin los resuelva, reflejándose en su agenda.",
  trigger: "El Empleado crea una solicitud desde su panel.",
  actors: ["Empleado", "Administrador", "Sistema"],
  status: "COMPLETO",
  description:
    "El empleado registra una solicitud (employee_requests) con tipo (reglamentaria, enfermedad, estudio, etc.), fechas y motivo. El admin la aprueba o rechaza con un comentario; si se aprueba, aparece como ausencia en el calendario del empleado.",
  lanes: [
    { id: "emp", actor: "Empleado" },
    { id: "admin", actor: "Administrador" },
    { id: "sys", actor: "Sistema" },
  ],
  steps: [
    { id: "s1", laneId: "emp", type: "start", label: "Crea una solicitud de licencia", description: "Elige tipo (reglamentaria/enfermedad/estudio/…), fechas (dateFrom–dateTo) y motivo.", evidence: "src/screens/employee/Solicitudes.jsx:92" },
    { id: "s2", laneId: "emp", type: "document", label: "Envía (status: pendiente)", description: "Crea el documento employee_requests en estado pendiente." },
    { id: "s3", laneId: "admin", type: "task", label: "Revisa la solicitud", description: "El admin la ve filtrada por estado/tipo/empleado.", evidence: "src/screens/admin/SolicitudesAdmin.jsx:140" },
    { id: "s4", laneId: "admin", type: "decision", label: "¿Aprueba o rechaza?" },
    { id: "s5", laneId: "admin", type: "task", label: "Aprueba (aprobada)", description: "Marca aprobada y agrega adminResponse." },
    { id: "s6", laneId: "admin", type: "task", label: "Rechaza (rechazada)", description: "Marca rechazada con el motivo en adminResponse." },
    { id: "s7", laneId: "sys", type: "task", label: "Refleja la ausencia en su agenda", description: "Si está aprobada, aparece como ausencia (OoO) en el calendario del empleado.", evidence: "src/screens/employee/TurnosEmployee.jsx:111" },
    { id: "s8", laneId: "emp", type: "notification", label: "Ve el resultado y el comentario" },
    { id: "s9", laneId: "emp", type: "end", label: "Licencia resuelta" },
  ],
  transitions: [
    { from: "s1", to: "s2" },
    { from: "s2", to: "s3" },
    { from: "s3", to: "s4" },
    { from: "s4", to: "s5", label: "aprueba" },
    { from: "s4", to: "s6", label: "rechaza" },
    { from: "s5", to: "s7" },
    { from: "s7", to: "s8" },
    { from: "s6", to: "s8" },
    { from: "s8", to: "s9" },
  ],
};

export default empleadosSolicitudes;
